const translations = {
    en: {
      welcomePrompt: ["Hello fellow traveller!", "This survey is being conducted in the context of my Master's thesis in Software Engineering at the University of Porto. It is intended to help me collect data on tourist preferences to train a Touristic Recommendation Model.", "When aswering the survey you will not be asked for any information that could identify you. The data collected will be confidential and used only for the academic context.","In case you have any questions about the survey, plese don't refrain from contacting me at up202000161@up.pt.", "The survey should last up to 10 minutes.", "Safe travels!"],
      demographicPrompt: "Before we begin, please fill in your demographic data",
      namePlaceholder: "Enter your first name",
      agePlaceholder: "Enter your age",
      genderPlaceholder: "Select your gender",
      male: "Male",
      female: "Female",
      other: "Other",
      countryPlaceholder: "Select country of origin",
      submit: "Submit",
      POITypePrompt: "What kinds of attractions and sights are you most interested in visiting when travelling?",
      history: "History",
      nature: "Nature",
      culture: "Culture",
      art: "Art",
      leisure: "Leisure",
      interest1: "I have no real interest in X",             
      interest2: "I have little interest in X", 
      interest3: "I have some interest in X",
      interest4: "I'm very interested in X", 
      interest5: "My priority when travelling is X",
      historyX: "historical sights",
      natureX: "natural sights and parks",
      cultureX: "local culture",
      artX: "art",
      leisureX: "leisurely activities",
      selectCitiesPrompt: "Out of the cities below, which ones have you visited?",
      selectCitiesPlaceholder: "Select all cities you've visited",
      selectPOIsPrompt: "Which attractions in X have you been to?",
      ratePOIsPrompt: "According to your personal interests, how would you rate the attractions in X you've been to from 1 to 5?",
      ratingPlaceholder: "1-5",
      thanks: "Thanks for helping me with my master's thesis X it means a lot. As a token of my appreciation here's a picture of a kitty to brighten your day :)",
      ratingWarning: "Must rate all attractions"
    },
    pt: {
      welcomePrompt: ["Olá viajante!", "Este inquérito está a ser realizado no âmbito da minha dissertação de Mestrado em Engenharia de Software pela Universidade do Porto. O seu objetivo é ajudar na recolha de dados sobre preferências turísticas, com vista ao treinamento de um Modelo de Recomendação Turística.", "Ao responder ao inquérito, não lhe será pedido qualquer dado que permita identificá-lo. As informações recolhidas serão tratadas com confidencialidade e utilizadas exclusivamente para fins académicos.", "Caso tenha alguma dúvida sobre o inquérito, não hesite em contactar-me através do email: up202000161@up.pt.", "O preenchimento do inquérito deverá demorar até 10 minutos.","Boas viagens!"],
      demographicPrompt: "Antes de começarmos, por favor preenche os seus dados demográficos.",
      namePlaceholder: "Digite seu primeiro nome",
      agePlaceholder: "Digite sua idade",
      genderPlaceholder: "Selecione seu gênero",
      male: "Masculino",
      female: "Feminino",
      other: "Outro",
      countryPlaceholder: "Selecione o país de origem",
      submit: "Submeter",
      POITypePrompt: "Que tipos de pontos turísticos mais te interessam visitar quando viajas?",
      history: "História",
      nature: "Natureza",
      culture: "Cultura",
      art: "Arte",
      leisure: "Lazer",
      interest1: "Eu não tenho real interesse por X",             
      interest2: "Eu tenho pouco interesse por X", 
      interest3: "Eu tenho algum interesse por X",
      interest4: "Eu tenho muito interesse por X", 
      interest5: "Minha prioridade quando viajo é X",
      historyX: "pontos turísticos históricos",
      natureX: "beleza natural e parques",
      cultureX: "cultura local",
      artX: "arte",
      leisureX: "atividades de lazer",
      selectCitiesPrompt: "Dentre as cidades abaixo, quais já visitaste?",
      selectCitiesPlaceholder: "Selecione todas as cidades visitadas",
      selectPOIsPrompt: "Quais pontos turísticos de X visitaste?",
      ratePOIsPrompt: "De acordo com os seus interesses pessoais, que nota, de 1 a 5, darias às atrações de X que visitaste?",
      ratingPlaceholder: "1-5",
      thanks: "Obrigado por me ajudar com a minha tese X. Como forma de agradecimento, toma uma foto de gatinho para alegrar o seu dia :)",
      ratingWarning: "Deves dar nota a todas as atrações"
    },
  };
  
  export default translations;

  export const translate = (key, language) => {
    return translations[language]?.[key] || translations['en'][key] || key;
  };
  